import { LeaguesCore } from '../../../../core/collections';
import { FixtureModel } from '../../models';

/**
 * @desc Table
 * This Collection using for leagues
 */
class Leagues extends LeaguesCore {
	get model() {
		return FixtureModel;
	}

	constructor( args ) {
		super( args );
		this.prefix = 'leagues_classic/';
		this.count_leagues = 0;
	}
}

export default Leagues;